import type { ImmutableState } from '../types';

export const getExternalLinks = (state: ImmutableState) => state.links;

export const getIsDeleting = (state: ImmutableState) => state.isDeleting;

export const getIsAdding = (state: ImmutableState) => state.isAdding;

export const getIsUpdating = (state: ImmutableState) => state.isUpdating;

export const getIsReordering = (state: ImmutableState) => state.isReordering;

export const getLinkIcon = (state: ImmutableState, linkUrl: string) => state.icons[linkUrl];
